import React, {useState} from 'react'
import SupplierFormItemProvider from "../providers/SupplierFormItemProvider";
import {useAuth} from "../../../providers/AuthProvider";
import SupplierProfileLinkForm from "./SupplierProfileLinkForm";
import SupplierProfileDocumentForm from "./SupplierProfileDocumentForm";

const SupplierLinksDocumentsStep = ({supplierOrg, onChange, onSave, ...props}) => {

    const {auth} = useAuth()
    const [editingIndex, setEditingIndex] = useState(false);

    const getTypeIndex = (type, index) => {
        return `${type}-${index}`
    }
    const getLinkIndex = (index) => {
        return getTypeIndex('link', index)
    }
    const getDocIndex = (index) => {
        return getTypeIndex('doc', index)
    }
    const addNewArrayProp = async (propName) => {

        let models = supplierOrg[propName] || []
        models.push({});

        await onChange({[propName]: models});
        return setEditingIndex(propName === 'profile_documents' ?
            getDocIndex(models?.length - 1) :
            getLinkIndex(models?.length - 1)
        )
    }
    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Links & Documents
                            </h3>

                            {/*{this.constructor.LastUpdatedMethod && this.renderLastUpdated(this.constructor.LastUpdatedMethod)}*/}
                        </div>

                        <h5 className="form-subtitle">
                            Share links to work or other materials that showcase your agency's skills and accomplishments.
                        </h5>
                    </div>
                </div>
            </div>

            {TB.map(supplierOrg?.profile_links || [], (link, linkIndex) => (
                <SupplierFormItemProvider
                    key={`link-${link.id}-${linkIndex}`}
                    itemIndex={linkIndex}
                    onSave={async (linkProps) => {

                        if (!linkProps) {
                            let profile_links = TB.filter([...supplierOrg?.profile_links], (links, lIndex) => {
                                return linkIndex !== lIndex;
                            });
                            if (link?.id) {
                                return onSave({profile_links}, true);
                            }
                            await onChange({profile_links})
                        }else {
                            let profile_links = TB.set([...supplierOrg?.profile_links], linkIndex, linkProps);
                            await onChange({profile_links});
                            await setEditingIndex(false);
                            onSave({profile_links}, true);
                        }
                    }}
                    model={link}
                    isUpdating={false}
                    isEditing={editingIndex === getLinkIndex(linkIndex)}
                    onEditing={(toggle) => {
                        setEditingIndex(toggle ? getLinkIndex(linkIndex) : false)
                    }}
                    displayName="Link"
                    itemPropName="profile_links"
                    className="add-link-form"
                    formStyle={{borderTop: `5px solid ${TB.config('color.info')}`}}
                >

                    <SupplierProfileLinkForm/>

                    <div className="form-profile-icon" style={{backgroundColor: TB.config('color.info')}}>
                        <i className="fas fa-link"/>
                    </div>

                </SupplierFormItemProvider>
            ))}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={false}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('profile_links')}>
                    Add Link #{supplierOrg?.profile_links?.length + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>

            {TB.map(supplierOrg?.profile_documents || [], (document, docIndex) => (
                <SupplierFormItemProvider
                    key={`doc-${document.id}-${docIndex}`}
                    itemIndex={docIndex}
                    onSave={async (docProps) => {

                        if (!docProps) {
                            let profile_documents = TB.filter([...supplierOrg?.profile_documents], (docs, lIndex) => {
                                return docIndex !== lIndex;
                            });
                            if (document?.id) {
                                return onSave({profile_documents}, true);
                            }
                            await onChange({profile_documents});
                        }else {
                            if(typeof docProps?.path === 'object' && docProps.path.name) {
                                docProps.name = docProps.path.name;
                            }
                            let profile_documents = TB.set([...supplierOrg?.profile_documents], docIndex, docProps);
                            await onChange({profile_documents});
                            await setEditingIndex(false);
                            onSave({profile_documents}, true);
                        }
                    }}
                    model={document}
                    isUpdating={false}
                    isEditing={editingIndex === getDocIndex(docIndex)}
                    onEditing={(toggle) => {
                        setEditingIndex(toggle ? getDocIndex(docIndex) : false)
                    }}
                    displayName="Document"
                    itemPropName="profile_documents"
                    className="add-doc-form"
                    formStyle={{borderTop: `5px solid ${TB.config('color.light_purple')}`}}
                >

                    <SupplierProfileDocumentForm/>

                    <div className="form-profile-icon" style={{backgroundColor: TB.config('color.light_purple')}}>
                        <i className="fas fa-file-alt"/>
                    </div>

                </SupplierFormItemProvider>
            ))}

            <div
                className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                <button
                    disabled={editingIndex}
                    className="btn btn-outline-dark" onClick={() => addNewArrayProp('profile_documents')}>
                    Add Document #{supplierOrg?.profile_documents?.length + 1} <i className="ml-1 fa fa-plus"/>
                </button>
            </div>
        </div>
    )
}
export default SupplierLinksDocumentsStep;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};